import { Link } from "react-router-dom";
import t from "../locales";

export default function NavBar({ icon }) {
  return (
    <nav className="nav-bar">
      <Link to="/apps" className="nav-bar__link">
        <svg
          className="nav-bar__link-icon"
          viewBox="0 0 36 36"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20.6828 33.1022L18.9486 34.8819C18.2143 35.6354 17.027 35.6354 16.3005 34.8819L1.11468 19.3058C0.380392 18.5523 0.380392 17.3338 1.11468 16.5882L16.2927 1.01218C17.027 0.258633 18.2143 0.258633 18.9408 1.01218L20.675 2.79184C21.4171 3.55341 21.4015 4.79597 20.6438 5.5415L11.2386 14.7364L33.6892 14.7364C34.7281 14.7364 35.564 15.5942 35.564 16.6604V19.2257C35.564 20.2918 34.7281 21.1496 33.6892 21.1496L11.2386 21.1496L20.6516 30.3525C21.4171 31.0981 21.4327 32.3406 20.6828 33.1022Z" />
        </svg>
        {t("nav_bar_apps")}
      </Link>
      <img src={icon} className="nav-bar__icon" />
    </nav>
  );
}
